/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import { withMultiProviders } from '../../../hoc/withProvider';
import { AuthContext } from '../../../providers/AuthProvider';
import MyAccountProvider, {
  MyAccountContext,
} from '../../../providers/MyAccountProvider';
import UploadProvider from '../../../providers/UploadProvider';
import PayorContractProvider from '../../../providers/PayorContractProvider';
import DepartmentPracticeInfo from './DepartmentPracticeInfo';
import HealthSystemPracticeInfo from './HealthSystemPracticeInfo';
import HospitalPracticeInfo from './HospitalPracticeInfo';
import PhysicianGroupPracticeInfo from './PhysicianGroupPracticeInfo';
import ProviderPracticeInfo from './ProviderPracticeInfo';
import { ClientType } from '../../../utils/clientTypeUtils';

const PracticeInfoWrapper = () => {
  const myAccountContext = useContext(MyAccountContext);
  const authContext = useContext(AuthContext);
  const currentUser = myAccountContext.currentUserType;

  useEffect(() => {
    myAccountContext.userTypeLookup();
  }, []);

  useEffect(() => {
    if (myAccountContext?.currentUserType) {
      myAccountContext.changeDashboardView(authContext.currentUser.user_type);
    }
  }, [myAccountContext.isGettingUserType])

  useEffect(() => {
    let type;
    if ((type = authContext?.currentUser?.user_type) && myAccountContext.currentUserType) {
      myAccountContext.changeDashboardView(type);
    }
  }, [authContext?.currentUser?.user_type]);

  const renderComponentByUser = () => {
    switch (currentUser?.type) {
      case ClientType.HEALTH_SYSTEM:
        return (
          <HealthSystemPracticeInfo
            id={currentUser?.health_system_id?.id}
            user={currentUser.type}
            status={currentUser.is_active}
          />
        );
      case ClientType.HOSPITAL:
        return (
          <HospitalPracticeInfo
            id={currentUser?.hospital_id?.id}
            user={currentUser.type}
            status={currentUser.is_active}
          />
        );
      case ClientType.DEPARTMENT:
        return (
          <DepartmentPracticeInfo
            id={currentUser?.department_id?.id}
            user={currentUser.type}
            status={currentUser.is_active}
          />
        );
      case ClientType.PHYSICIANS_GROUP:
        return (
          <PhysicianGroupPracticeInfo
            id={currentUser?.physicians_group_id?.id}
            user={currentUser.type}
            status={currentUser.is_active}
          />
        );
      case ClientType.PROVIDER:
        return (
          <ProviderPracticeInfo
            id={currentUser?.id}
            user={currentUser.type}
            status={currentUser.is_active}
          />
        );

      default:
        return;
    }
  };

  return <>{renderComponentByUser()}</>;
};

export default withMultiProviders([MyAccountProvider, UploadProvider, PayorContractProvider], PracticeInfoWrapper);
